export default __webpack_public_path__ + "static/media/careplan_img_dashboard.14159713.svg";